import { Injectable } from '@angular/core';
import { PlayResult, PlayRequest } from './sound.model';


// TODO: Legado do código anterior, para retirar precisa mudar no manual mapping e np wizard
export const AvailableSounds = [
  { name: 'Nenhum', function: null },
  { name: 'Detector', function: 'detector' },
  { name: 'Bambu', function: 'knock' },
  { name: 'Tulum', function: 'tulum' },
  { name: 'Whoosh', function: 'whoosh' },
  { name: 'Pling', function: 'pling' },
  { name: 'Sci-Fi', function: 'scifi' },
  { name: 'Click', function: 'click' },
  { name: 'Rolha', function: 'cork' },
  { name: 'Processando', function: 'processing' },
  { name: 'Correto', function: 'correct' },
  { name: 'Errado', function: 'wrong' },
];

@Injectable({
  providedIn: 'root'
})
export class SoundService {

  currentSounds: PlayRequest[] = [];
  try: number;
  globalVolume = 1; // TODO: remover quando tiver a configuração de volume do sistema

  audioChunks = [];
  audioStack: Array<AudioBuffer> = [];
  nextTime = 0;

  constructor() {
    this.try = 0;
    for (let i = 0; i < 4; i++) { // Inicializa o vetor das tracks
      this.currentSounds.push({} as PlayRequest);
    }
  }

  requestSound(source: string, track: number, volume: number) {
    this.try++;
    //console.log('[Sound] request:', source, track, ' current:',this.currentSounds.length, 'try:', this.try, this.currentSounds);
    const promise = new Promise<PlayResult>((resolve, reject) => {
      if (track > 4) { reject('Invalid track'); return; }
      // Testa se a faixa está disponível. Se não estiver, interrompe o som atual
      if (this.currentSounds[track].track !== undefined) {
        //console.log('[Sound] interrupted', this.currentSounds[track].source, this.currentSounds[track].audio, 'try:', this.try);
        this.currentSounds[track].audio.pause();
        this.currentSounds[track].audio.currentTime = 0;
        this.currentSounds[track].promiseResolve(PlayResult.interrupted);
      }

      const audio = new Audio();
      audio.src = source;

      // -------- Volume ------------
      audio.volume = volume * this.globalVolume;
      for (let i = 0; i < this.currentSounds.length; i++) {
        if (this.currentSounds[i].track !== undefined && this.currentSounds[i].track < track) {
          this.currentSounds[i].audio.volume = this.currentSounds[i].audio.volume * 0.5;
          //console.log('[Sound] lower volume', this.currentSounds[i].source, 'try:', this.try, 'volume:', this.currentSounds[i].audio.volume);
        }
      }
      // -------- Play ------------
      audio.load();
      this.currentSounds[track] = { source, track, volume, promiseResolve: resolve, promiseReject: reject, audio };
      audio.play().then(() => { }, (err) => {
        this.currentSounds[track].promiseReject(err);
      });
      // --------- OBS ------------
      //audio.addEventListener('play', () => { console.log('[Sound] play', this.currentSounds[track].source, 'try:', this.try, 'volume:', this.currentSounds[track].volume); });
      this.currentSounds[track].endCallback = () => this.endCallback(track);
      audio.addEventListener('ended', this.currentSounds[track].endCallback);
    });
    return promise;
  }

  endCallback(index) {
    //console.log('[Sound] endCallback', index, this.try,'time:', performance.now(), this.currentSounds[index]);
    this.currentSounds[index].promiseResolve(PlayResult.success);
    this.currentSounds[index].audio.removeEventListener('ended', this.currentSounds[index].endCallback); // TODO: Verificar se realmente
    this.currentSounds[index] = {} as PlayRequest;
  }

  pauseRequest(track: number, fileUri: string) {
    if (!fileUri || track < 0 || track >= this.currentSounds.length) {
      console.warn('[Sound] pauseRequest: invalid track', fileUri, track);
      return Promise.reject(PlayResult.notFound);
    }
    track = track || 0;

    if (this.currentSounds[track]?.audio) {
      this.currentSounds[track].audio.pause();
      this.currentSounds[track].promiseResolve(PlayResult.paused);
      console.log('[Sound] pauseRequest', fileUri, track);
      return Promise.resolve(PlayResult.paused);
    } else {
      console.warn('[Sound] pauseRequest: track not found', fileUri, track);
      return Promise.reject(PlayResult.notFound);
    }
  }

  resumeRequest(track: number, fileUri: string) {
    track = track || 0;

    if (this.currentSounds[track]?.audio) {
      this.currentSounds[track].audio.play()
        .then(() => {
          console.log('[Sound] resumeRequest', fileUri, track);
        })
        .catch(err => {
          console.error('[Sound] resumeRequest error', err);
        });

      return Promise.resolve(PlayResult.resumed);
    } else {
      console.warn('[Sound] resumeRequest: track not found', fileUri, track);
      return Promise.reject(PlayResult.notFound);
    }
  }

  endRequest() {
    for (let i = 0; i < this.currentSounds.length; i++) {
      if (this.currentSounds[i].track !== undefined) {
        console.log('[Sound] endRequest', this.currentSounds[i].source, 'track:', i);
        this.currentSounds[i].audio.pause();
        this.currentSounds[i].audio.currentTime = 0;
        this.currentSounds[i].promiseResolve(PlayResult.interrupted);
      }
    }
  }


  cleanupSound(track: number) {
    const current = this.currentSounds[track];
    if (current) {
      try {
        current.audio.pause();
        current.audio.currentTime = 0;

        // Remove event listeners
        if (current.endCallback) {
          current.audio.removeEventListener('ended', current.endCallback);
        }

        // Resolve qualquer promise pendente para evitar memória pendente
        current.promiseResolve(PlayResult.stopped);

        // Remove a referência do objeto
        delete this.currentSounds[track];

        console.log('[Sound] cleanupSound', track);
      } catch (err) {
        console.error('[Sound] Error in cleanupSound', err);
      }
    }
  }

  cleanupAllSounds() {
    for (let i = 0; i < this.currentSounds.length; i++) {
      if (this.currentSounds[i]) {
        this.cleanupSound(i);
      }
    }
  }

  // Retorna o vetor de sons atuais
  getCurrentSounds() {
    return this.currentSounds;
  }

  // Retorna o som atual de uma faixa específica
  // Se a faixa não estiver em uso, retorna um objeto vazio
  getSoundByTrack(track: number) {
    return this.currentSounds[track];
  }

  // Retorna os sons disponíveis
  getAvailableSounds() {
    return AvailableSounds;
  }

}
